module.exports = __webpack_public_path__ + "img/button-spin-th.a3df107c.webp";